// Reference: blueprint:javascript_object_storage
import { useState } from "react";
import type { ReactNode } from "react";
// @ts-expect-error - Uppy packages are installed but react-scripts type checker has issues
import Uppy from "@uppy/core";
// @ts-expect-error - Uppy packages are installed but react-scripts type checker has issues
import { DashboardModal } from "@uppy/react";
// @ts-expect-error - Uppy packages are installed but react-scripts type checker has issues
import AwsS3 from "@uppy/aws-s3";

interface ObjectUploaderProps {
  maxNumberOfFiles?: number;
  maxFileSize?: number;
  onGetUploadParameters: () => Promise<{
    method: "PUT";
    url: string;
  }>;
  onComplete?: (result: any) => void;
  buttonClassName?: string;
  children: ReactNode;
}

export function ObjectUploader({
  maxNumberOfFiles = 1,
  maxFileSize = 10485760,
  onGetUploadParameters,
  onComplete,
  buttonClassName,
  children,
}: ObjectUploaderProps) {
  const [showModal, setShowModal] = useState(false);
  const [uppy] = useState(() =>
    new Uppy({
      restrictions: {
        maxNumberOfFiles,
        maxFileSize,
        allowedFileTypes: ['image/*'],
      },
      autoProceed: false,
    })
      .use(AwsS3, {
        shouldUseMultipart: false,
        getUploadParameters: onGetUploadParameters,
      })
      .on("complete", (result: any) => {
        onComplete?.(result);
        setShowModal(false);
      })
  );

  return (
    <div>
      <button 
        type="button"
        onClick={() => setShowModal(true)} 
        className={buttonClassName}
      >
        {children}
      </button>

      <DashboardModal
        uppy={uppy}
        open={showModal}
        onRequestClose={() => setShowModal(false)}
        proudlyDisplayPoweredByUppy={false}
      />
    </div>
  );
}
